import { useI18n } from 'next-localization';
import { getAvailableTabs } from '@/store/fundDetails';
import { AvailableTabs } from '@/store/fundDetails/typings';
import { useSelector } from 'react-redux';
import FundDetailsPremiumDiscountLineChartSection from './FundDetailsPremiumDiscountLineChartSection';
import FundDetailsPremiumDiscountBarChartSection from './FundDetailsPremiumDiscountBarChartSection';

const FundDetailsPremiumDiscountTab = () => {
  const { t } = useI18n();
  const availablePremiumDiscountTabs: AvailableTabs =
    useSelector(getAvailableTabs)?.premiumDiscountTab;

  return (
    <section className="default-section-padding background-white">
      <div className="container">
        <h2>{t('fundDetailsPremiumDiscountTitle')}</h2>

        {availablePremiumDiscountTabs && availablePremiumDiscountTabs.lineGraphSection && (
          <FundDetailsPremiumDiscountLineChartSection className="mt-6" />
        )}
        {availablePremiumDiscountTabs && availablePremiumDiscountTabs.chartSection && (
          <FundDetailsPremiumDiscountBarChartSection className="mt-6" />
        )}
      </div>
    </section>
  );
};

export default FundDetailsPremiumDiscountTab;
